import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { ProductBOMSetupPopup } from './productBOMSetupTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import DailyReportsServices from '../../../services/axiosServices/apiServices/DailyReportsServices';
import moment from 'moment';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class ProductBOMSetup extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.dailyReportsServices = new DailyReportsServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            rowData: [],
            colDefs: [],
            table2Data: [],
            table2ColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            colName: "",
            caption: "",
            isSelectItemPopUp: false,
            isSelectItemPopUp2: false,
            productObject: {
                idProductReceipe: 0,
                eDate: "",
                updateStatus: 0,
                BOMFromId: 1,
                BOMFromList: [
                    {
                        value: 1,
                        label: "Manually"
                    },
                    {
                        value: 2,
                        label: "Old BOM"
                    },
                ],
                oldProductList: [],
                oldProductListHold: [],
                oldProductID: 0,
                itemTypeId: 2,
                types: [
                    {
                        value: 1,
                        label: "RAW MATERIAL"
                    },
                    {
                        value: 2,
                        label: "FINISHED GOODS"
                    },
                    {
                        value: 3,
                        label: "SEMI FINISHED"
                    },
                ],
                itemTypeId2: 1,
                itemId: 0,
                itemIdLabel: "",
                itemList: [],
                itemList2: [],
                itemId2: 0,
                itemId2Label: "",
                drawingNo: "",
                quantity: 0,
                keyId: 0,
                processRowData: [],
                processColdefs: [
                    {
                        field: "drawingNo",
                        headerName: "Drawing No",
                        flex: 1.5,
                        filter: true,
                    },
                    {
                        field: "type",
                        headerName: "Select Type",
                        // minWidth: window.innerWidth * 0.08,
                        flex: 1.5,
                        filter: true,
                    },
                    {
                        field: "itemDetails",
                        headerName: "Select Item",
                        flex: 1.5,
                        filter: true,
                    },
                    {
                        field: "quantity",
                        headerName: "Quantity",
                        // minWidth: window.innerWidth * 0.08,
                        flex: 1.5,
                        filter: true,
                    },

                ],
            },
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategoryDesc",
                    headerName: "Item Category Desc",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                itemId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
            },
            validationRulesForItem: {
                drawingNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "drawing no"
                        ),
                    },
                ],
                itemId2: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            // this.getMasterExpenseAccGroupCount();
        })
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idProductReceipe, this.state.caption);
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getMaster_ProductReceipeSelectbyIdForEdit(event.data.idProductReceipe);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    handleCellClickItemList = (event) => {
        //this.getMaster_ItemSelectbyItemType();
        //this.setState({ idCompany : this.state.idCompany}, () => {
        this.editItemListItems(event.data.type, event.data.idItem, event.data.keyId);
        //});
        // let validState = this.state.validState;
        // validState.isValid = true;
        // validState.error = {};
        // this.setState({
        //     validState: validState
        // });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.productObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsForItem = () => {
        const newValidState = isValidForm(
            this.state.productObject,
            this.state.validationRulesForItem,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.productObject;
        details[name] = value;
        this.setState({ productObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let productObject = this.state.productObject;
        productObject.idProductReceipe = "";
        //productObject.processName = "";
        //productObject.processDesc = "";
        //productObject.remarks = "";
        productObject.BOMFromId = 1;
        productObject.oldProductList = [];
        //productObject.oldProductListHold: [],
        productObject.oldProductID = 0;
        productObject.itemTypeId = 2;
        productObject.itemTypeId2 = 1;
        productObject.itemId = 0;
        productObject.itemIdLabel = "";
        //productObject.itemList = [];
        //productObject.itemList2 = [];
        productObject.itemId2 = 0;
        productObject.itemId2Label = "";
        productObject.drawingNo = "";
        productObject.quantity = 0;
        productObject.keyId = 0;
        productObject.eDate = "";
        productObject.updateStatus = 0;
        productObject.processRowData = [];
        this.setState({
            productObject: productObject, validState: validState
        }, () => {
            this.getMaster_ItemSelectbyItemType("FINISHED GOODS", "itemTypeId");
            this.getMaster_ItemSelectbyItemType("RAW MATERIAL", "itemTypeId2");
        });
    }

    handleChangeFroDropdown = (event, name) => {
        //debugger;
        let details = this.state.productObject;
        let value = event.value;
        // if (name === 'rateOn' || name === 'itemType') {
        //     details[name] = event.label;
        // } else {
        details[name] = value;
        //}
        this.setState({ productObject: details }, () => {
            if (name === 'BOMFromId') {
                let data = this.state.productObject;
                if (event.label === 'Old BOM') {
                    data.oldProductList = data.oldProductListHold;
                } else {
                    data.oldProductList = [];
                }
                this.setState({ productObject: data });
            }
            else if (name === 'oldProductID') {
                this.getMaster_ProductReceipeSelectbyId(value)
            } else if (name === 'itemTypeId' || name === 'itemTypeId2') {
                this.getMaster_ItemSelectbyItemType(event.label, name);
            } else if (name === 'itemId2') {
                this.getMaster_ItemSelectbyID(value);
            }
        });
    }

    handleOnClick = (event, name) => {
        //debugger
        if (name === 'itemList') {
            this.setOpenModel2();
        }
        if (name === 'itemList2') {
            this.setOpenModel3();
        }
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    setOpenModel3 = () => {
        this.setState({ isSelectItemPopUp2: !this.state.isSelectItemPopUp2 });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.productObject;
        data.itemId = event.data.idItem;
        data.itemIdLabel = event.data.itemName;
        this.setState({ productObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick2 = (event) => {
        let data = this.state.productObject;
        data.itemId2 = event.data.idItem;
        data.itemId2Label = event.data.itemName;
        data.drawingNo = event.data.drawingNo;
        this.setState({ productObject: data, isSelectItemPopUp2: !this.state.isSelectItemPopUp2 });
    };

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getAllDropdownForStockMaster();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Product BOM Setup",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idProductReceipe"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Product BOM Setup",
                            colName: colName,
                            isTable2Expanded: true,
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id, "Product BOM Setup");
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "productCategory": window.innerWidth * 0.1,
            "drawingNo": window.innerWidth * 0.13,
            "productName": window.innerWidth * 0.25,
            "unitDescription": window.innerWidth * 0.1,
            "status": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            //idCompany: this.state.prop.idCompany
        }
        //debugger
        this.dailyReportsServices.procSelectAllRecord2GridviewSP(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                const dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                        field: key,
                        headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                        flex: 1
                    }));
                    this.setState({
                        table2Data: dynamicData,
                        table2ColDefs: dynamicColDefs
                    });
                } else {
                    this.setState({
                        table2Data: [],
                        table2ColDefs: [],
                        isTable2Expanded: true,
                    });
                }
            }
        });
    }

    getAllDropdownForStockMaster = () => {
        this.masterEntryServices.getAllDropdownForStockMaster(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.productObject;
                data.oldProductListHold = allData.filter(item => item.source === 'Master_ProductReceipeForBOM');

                let dynamicData = data.oldProductListHold.map((x) => ({
                    value: x.value,
                    drawingNo: x.label,
                    label: x.name2,
                }));

                data.oldProductListHold = dynamicData;
                this.setState({
                    productObject: data
                }, () => {
                    //this.usp_Master_EmployeeSelect()
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getMaster_ProductReceipeSelectbyId = (id) => {
        this.masterEntryServices.getMaster_ProductReceipeSelectbyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                let itemObject = this.state.productObject;
                let itemListRowData = itemObject.processRowData;
                res.itemList?.map((x) => {
                    let object = {
                        type: x.itemType,
                        drawingNo: x.drawingNo,
                        itemDetails: x.itemName,
                        idItem: x.idItem,
                        quantity: x.quantity,
                    }
                    itemListRowData.push(object);
                });
                itemObject.processRowData = [...itemListRowData];
                itemObject.processRowData.map((x, key) => {
                    x.keyId = key + 1;
                });
                this.setState({
                    productObject: itemObject,
                }, () => {
                });
            }
        });
    }

    getMaster_ProductReceipeSelectbyIdForEdit = (id) => {
        if (id > 0) {
            this.masterEntryServices.getMaster_ProductReceipeSelectbyId(id).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent;
                    let itemObject = this.state.productObject;
                    itemObject.idProductReceipe = res.idProductReceipe;
                    itemObject.BOMFromId = itemObject.BOMFromList.find(x => x.label === res.type).value;
                    itemObject.oldProductList = itemObject.BOMFromId === 2 ? itemObject.oldProductListHold : [];
                    //oldProductID: 0,
                    itemObject.itemTypeId = itemObject.types.find(x => x.label === res.productType).value;
                    //types: [],
                    itemObject.itemTypeId2 = 1;
                    itemObject.itemId = res.idProduct;
                    itemObject.eDate = res.e_Date;
                    itemObject.updateStatus = 1;
                    let itemListRowData = []; //itemObject.processRowData;
                    res.itemList?.map((x) => {
                        let object = {
                            type: x.itemType,
                            drawingNo: x.drawingNo,
                            itemDetails: x.itemName,
                            idItem: x.idItem,
                            quantity: x.quantity,
                        }
                        itemListRowData.push(object);
                    });
                    itemObject.processRowData = [...itemListRowData];
                    itemObject.processRowData.map((x, key) => {
                        x.keyId = key + 1;
                    });
                    let request = [res.productType, this.state.idCompany];
                    this.masterEntryServices.getMaster_ItemSelectbyItemType(request).then((response2) => {
                        if (response2.statusCode === 200 && response2.responseItem !== null) {
                            let data = response2.responseItem.responseContent;
                            //let itemObject = this.state.productObject;
                            // data = data.map((x) => ({
                            //     value: x.idItem,
                            //     label: x.itemName,
                            // }));
                            if (data.length > 0) {
                                itemObject.itemList = data;
                                itemObject.itemId = "";
                            }
                            itemObject.itemId = res.idProduct;
                            itemObject.itemIdLabel = res.idProduct > 0 ? itemObject.itemList.find(x => x.idItem === res.idProduct)?.itemName : "";
                            itemObject.oldProductID = res.idOldBom > 0 ? itemObject.oldProductList.find(x => x.value === res.idOldBom)?.value : 0;
                            this.setState({
                                productObject: itemObject,
                            });
                        }
                    });
                    this.setState({
                        productObject: itemObject,
                        isModalOpen: true,
                    }, () => {
                        this.getMaster_ItemSelectbyItemType('RAW MATERIAL', "itemTypeId2");
                    });
                }
            });
        }
    }

    getMaster_ItemSelectbyItemType = (label, name) => {
        let request = [label, this.state.idCompany];
        this.masterEntryServices.getMaster_ItemSelectbyItemType(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.productObject;
                // data = data.map((x) => ({
                //     value: x.idItem,
                //     label: x.itemCategory + ' - ' + x.itemName + ' - ' + x.drawingNo + ' - ' + x.searchText,
                // }));

                if (name === 'itemTypeId2') {
                    itemObject.itemList2 = data;
                    itemObject.itemId2 = "";
                } else if (name === 'itemTypeId') {
                    itemObject.itemList = data;
                    itemObject.itemId = "";
                }
                this.setState({
                    productObject: itemObject,
                });
            }
        });
    }

    getMaster_ItemSelectbyID = (id) => {
        this.masterEntryServices.getItemMasterSelectbyID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let itemObject = this.state.productObject;
                itemObject.drawingNo = data.drawingNo;
                itemObject.itemTypeId2 = data.itemType ? itemObject.types.find(x => x.label === data.itemType).value : 0;
                this.setState({
                    productObject: itemObject,
                });
            }
        });
    }

    insert = (isFor) => {
        const isValidAllFields = this.isValidAllFieldsForItem();
        if (isValidAllFields) {
            let itemObject = this.state.productObject;
            let itemListRowData = itemObject.processRowData;
            //res.itemList?.map((x) => {
            let object = {
                type: itemObject.types?.find(x => x.value === itemObject.itemTypeId2)?.label,
                drawingNo: itemObject.drawingNo,
                itemDetails: itemObject.itemId2Label,
                idItem: itemObject.itemId2,
                quantity: Number(itemObject.quantity),
            }
            //itemListRowData.push(object);
            //});
            if (isFor === "Update") {
                itemListRowData[itemObject.keyId - 1] = object;
            } else {
                itemListRowData.push(object);
            }
            itemObject.processRowData = [...itemListRowData];
            itemObject.processRowData.map((x, key) => {
                x.keyId = key + 1;
            })
            this.setState({
                productObject: itemObject,
            }, () => {
                this.resetItemDetails()
            });
        }
    }

    resetItemDetails = () => {
        let reset = this.state.productObject;
        reset.drawingNo = "";
        reset.quantity = 0;
        reset.drawingNo = "";
        reset.itemId2 = 0;
        reset.keyId = 0;
        reset.itemId2Label = ''

        this.setState({
            productObject: reset,
        });
    }

    clear = () => {
        const itemObject = { ...this.state.productObject };
        const itemListRowData = [...itemObject.processRowData];
        itemListRowData.splice(itemObject.keyId - 1, 1);
        itemObject.processRowData = itemListRowData;
        this.setState({ productObject: itemObject });
    }

    editItemListItems = (type, idItem, keyId) => {
        let request = [type, this.state.idCompany];
        this.masterEntryServices.getMaster_ItemSelectbyItemType(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.productObject;
                // data = data.map((x) => ({
                //     value: x.idItem,
                //     label: x.itemName,
                // }));
                itemObject.itemList2 = data;

                this.setState({
                    productObject: itemObject,
                }, () => {
                    let data = this.state.productObject;
                    let findItemData = data.processRowData.find(col => col.keyId === keyId && col.idItem === idItem);
                    data.drawingNo = findItemData.drawingNo;
                    data.itemTypeId2 = data.types?.find(x => x.label === findItemData.type)?.value;
                    data.itemId2 = findItemData.idItem;
                    data.itemId2Label = findItemData.idItem > 0 ? data.itemList2?.find(x => x.idItem === findItemData.idItem)?.itemName : "";
                    data.quantity = findItemData.quantity;
                    data.keyId = keyId;
                    this.setState({ productObject: data });
                });
            }
        });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            if (this.state.productObject.processRowData.length === 0) {
                this.SwalServices.Error("Please add item details.");
            } else {
                let details = this.state.productObject;
                let requestData = {
                    type: details.BOMFromList?.find(x => x.value === details.BOMFromId)?.label,
                    idOldBom: details.oldProductID,
                    idProductReceipe: details.idProductReceipe,
                    idProduct: details.itemId,
                    productType: details.types?.find(x => x.value === details.itemTypeId)?.label,
                    isProduct: 0,
                    isItem: 1,
                    idCompany: this.state.idCompany,
                    e_Date: details.eDate && details.eDate !== 'Invalid date' ? details.eDate : new Date().toISOString(),
                    isUpdated: details.updateStatus === 1 ? true : null,
                    updatedDate: details.updateStatus === 1 ? new Date().toISOString() : null,
                    isDeleted: false,
                    deletedDate: null,
                    itemList: details.processRowData,
                };
                this.masterEntryServices.submitProductReceipeItemMaster(requestData)
                    .then((response) => {
                        if (response.statusCode === 200 && response.responseItem !== null) {
                            let dynamicData = response.responseItem.responseContent;
                            if (dynamicData !== null) {
                                if (dynamicData.errorType === 'Exists') {
                                    this.SwalServices.Warning(dynamicData.errorMessage);
                                } else {
                                    if (this.state.productObject.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }
                                    this.resetDetailsFields();
                                    // Call resetFields here after submission
                                    this.setState(
                                        { isModalOpen: false },
                                        () => {
                                            this.procSelectAllRecordsSP(); // Fetch latest records
                                        }
                                    );
                                }
                            } else {
                                this.procSelectAllRecordsSP();
                            }
                        } else {
                            this.setState(
                                { isModalOpen: false },
                                () => {
                                    this.SwalServices.Error(response.message);
                                    this.procSelectAllRecordsSP(); // Fetch latest records
                                }
                            );
                        }
                    });
            }
        }
    };

    render() {
        return (
            <>
                <div className='tax-structure-master'>
                    <div className='data-display'>
                        <div className='data-display-inner relative'>
                            <ButtonGrp buttons={['add', 'print', 'delete']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    //update: () => this.openPopUpForEditingItem(),
                                    print: this.handlePrint,
                                    delete: this.handleDelete,
                                }}
                            />
                            <ProductBOMSetupPopup
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                productObject={this.state.productObject}
                                handleChange={this.handleChange.bind(this)}
                                close={this.closePopup.bind(this)}
                                submit={this.submit.bind(this)}
                                validState={this.state.validState}
                                handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                                insert={this.insert.bind(this)}
                                clear={this.clear.bind(this)}
                                handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                                handleOnClick={this.handleOnClick.bind(this)}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 h-[58vh] w-full px-[1px] rounded-[5px]">
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Product BOM setup</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onCellClicked={this.handleCellClick}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        onGridReady={this.onGridReady}
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    />
                                </div>
                            </div>

                            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                    <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.table2Data}
                                        columnDefs={this.state.table2ColDefs}
                                        rowHeight={this.state.rowHeight}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.onGridReady}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.productObject.itemList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    //handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.productObject.itemList2}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp2}
                    setOpenModel={this.setOpenModel3.bind(this)}
                    //handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick2}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
            </>
        )
    }
}
